module.exports = __webpack_public_path__ + "static/media/Logo-Helmond.08d137d0.svg";